import React from 'react';
import './browse_date_picker.less';
import DatePicker from 'react-datepicker';
import '../../components/calendar/calendar.less';
import moment from 'moment';

export default class BrowseDatePicker extends React.Component{

  constructor(props){
    super(props);
    let delivaryFrom = this.props.browseFilter.delivaryFrom ;
    let delivaryTo = this.props.browseFilter.delivaryTo;
    (delivaryFrom == undefined || delivaryFrom == '') ? (delivaryFrom = '') : (delivaryFrom = moment(this.props.browseFilter.delivaryFrom*1000));
    (delivaryTo == undefined || delivaryTo == '') ? (delivaryTo = '') : (delivaryTo = moment(this.props.browseFilter.delivaryTo*1000));
    this.state = {
      delivaryFrom: delivaryFrom,
      delivaryTo:  delivaryTo,
      currState: this.props.currState
    }
  }

  componentWillReceiveProps(newProps){
    let delivaryFrom = newProps.browseFilter.delivaryFrom;
    let delivaryTo = newProps.browseFilter.delivaryTo;
    (delivaryFrom == undefined || delivaryFrom == '' ) ? (delivaryFrom = '') : (delivaryFrom = moment(newProps.browseFilter.delivaryFrom*1000));
    (delivaryTo == undefined || delivaryTo == '' ) ? (delivaryTo = '') : (delivaryTo = moment(newProps.browseFilter.delivaryTo*1000));
    this.setState({
      delivaryFrom: delivaryFrom,
      delivaryTo:  delivaryTo,
      currState: newProps.currState
    });
  }

  onChange = (value) => {

    let delivaryFromTimestamp;
    let delivaryToTimestamp;
    let browseFilter = Object.assign({}, this.props.browseFilter)
    const {state} = this;

    if(value != undefined){
      if(state.currState == 'delivaryFrom'){
        this.setState({delivaryFrom: value});
        delivaryFromTimestamp = value.unix();
      }else{
        this.setState({delivaryTo: value});
        delivaryToTimestamp = value.unix();
      }
      if(delivaryFromTimestamp != undefined){
        browseFilter.delivaryFrom = delivaryFromTimestamp;
      }
      if(delivaryToTimestamp != undefined){
        browseFilter.delivaryTo = delivaryToTimestamp;
      }
    }else{
      if(state.currState == 'delivaryFrom'){
        this.setState({delivaryFrom: ''});
        browseFilter.delivaryFrom = '';
      }else{
        this.setState({delivaryTo: ''});
        browseFilter.delivaryTo = '';
      }
    }
    this.props.updateParentStateCallback(browseFilter);

  }

  render(){
    let currState = this.state.currState;
    let selected;
    let currDate = moment();
    (currState == 'delivaryFrom') ? (selected = this.state.delivaryFrom) : (selected = this.state.delivaryTo);

    return(
        <div>
          { (currState == 'delivaryFrom') &&  <DatePicker
          selected={this.state.delivaryFrom}
          onChange={this.onChange}
          dateFormat="DD/MM/YYYY"
          minDate={moment()}
          disabled={this.props.disabled}
          placeholderText= {this.props.placeholderText} /> }

          { (currState == 'delivaryTo') && <DatePicker
          selected={this.state.delivaryTo}
          onChange={this.onChange}
          dateFormat="DD/MM/YYYY"
          minDate={moment()}
          disabled={this.props.disabled}
          placeholderText= {this.props.placeholderText} /> }
        </div>
    )
  }
}

// BrowseDatePicker.propType = {
//   errorMessage: React.PropTypes.string.isRequired
// }



// WEBPACK FOOTER //
// app/browse_packages/browse_filter/browse_date_picker.jsx